export default "__VITE_ASSET__CQ$cX8Lo__"